import React, { useMemo } from "react"
import { cva } from "class-variance-authority"

import "./Card.css"
import cn from "../../../../utils/classes"

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  fullHeight?: boolean
  rounded?: boolean
  borderStyleOverride?: string
  styleOverrides?: string
  isTooltipCard?: boolean
  tooltipPosition?: "left" | "right" | "top" | "bottom"
}

export const borderStyleOverrideDefault = "shadow-dark box-border"

const Card: React.FC<React.PropsWithChildren<CardProps>> = ({
  children,
  fullHeight = false,
  rounded = false,
  borderStyleOverride = borderStyleOverrideDefault,
  styleOverrides,
  isTooltipCard = false,
  tooltipPosition = "right",
  ...rest
}) => {
  const variants = cva(["relative", "w-full", "bg-white", "m-1/4", "p-4"], {
    variants: {
      fullHeight: {
        true: "h-full",
      },
      rounded: {
        true: "rounded-lg",
      },
    },
  })

  const shouldBeRounded = rounded || isTooltipCard

  const className = useMemo(() => {
    return cn(
      variants({ fullHeight, rounded: shouldBeRounded }),
      borderStyleOverride,
      styleOverrides,
      isTooltipCard && "border-t border-t-gray-200",
    )
  }, [
    fullHeight,
    borderStyleOverride,
    styleOverrides,
    variants,
    shouldBeRounded,
    isTooltipCard,
  ])

  return (
    <div className={className} {...rest}>
      {isTooltipCard && (
        <div
          className={cn(
            tooltipPosition === "left" && "tooltip-left rounded-lg",
            tooltipPosition === "right" && "tooltip-right rounded-lg",
            tooltipPosition === "top" && "tooltip-top rounded-lg",
            tooltipPosition === "bottom" && "tooltip-bottom rounded-lg",
          )}
        />
      )}
      {children}
    </div>
  )
}

export default Card
